/**
 * WHO IS SIGNED IN, FOR THE DESIGN SURFACE (spec §66R).
 *
 * A design now records who drew it, so the Design tab has to be able to tell
 * "mine" from "somebody else's" — to label it, and to put the drawing tools
 * away for a plan the signed-in person is only looking at.
 *
 * That is the whole purpose of this module. It is NOT an authorization
 * mechanism: nothing is decided from it that the server does not decide
 * again, and on the desktop there is no account at all, which is exactly the
 * case where every design is the owner's own.
 */
let accountId: string | null = null;

export function setCurrentAccountId(id: string | null): void {
  accountId = id;
}

export function currentAccountId(): string | null {
  return accountId;
}
